import { useGlobalUnreadListener } from '@avanta/shared/hooks/chat/useGlobalUnreadListener';
import { Outlet } from 'react-router';
import { Sidebar } from 'components/Layout/Sidebar';
import { Notifications } from './Notifications';

export const Layout = (): React.ReactElement => {
  useGlobalUnreadListener();

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex min-h-0 flex-1 flex-col overflow-x-hidden">
        <main className="container mx-auto max-w-7xl flex-1 px-6 py-6">
          <Outlet />
        </main>
        <Notifications />
      </div>
    </div>
  );
};
